// extracted by mini-css-extract-plugin
export default {"disclaimer":"PublicToken_disclaimer__mLvQs","link":"PublicToken_link__L5Kqa"};